//WHEN USE THE FUNCTION TIME
$( document ).ready(function() {
    var dateServer = "{{'now' | date: '%B %d, %Y %I:%M %p %Z'}}";
    var startPreorder = $("#startPreorder").val();
    var tsuffix = $("#tsuffix").val();
    var durationEnd = $("#durationEnd").val();
    
    //when the time is end
    if(durationEnd <= 0  && tsuffix == "pre-order-with-time")
    {
    }
  
  
  	//when is preview, all the time is block
    if(tsuffix == "preview")
    {
        $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" disabled>'+ 
          '<input id="pre" value="pre-order" hidden="" >'+  
          '<span id="buttonTXT" data-add-to-cart-text="" >Preview</span>'+   
          '</button>');
    }
    fValidateSite();
});



//to block user, when user dont use the vipcode
function fValidateSite()
{
  var collectionName = $("#collectionName").val();
  var vipCode = sessionStorage.getItem('vipCode');

  if(collectionName == "Exclusive Private Backpack Sale"){
     /* if(vipCode != "1"){
        window.location.href="https://www.mikoleon.com/"
      }*/
  }

}
 
  
//when user change variants, time preorder
$("#SingleOptionSelector-0").on('change', function() {  
    var startPreorder = $("#startPreorder").val();
    var tsuffix = $("#tsuffix").val();
    var durationEnd = $("#durationEnd").val();
    var disabledButton = $("#disabledButton").val();
    var disabledButtonForm = $("#x").val();
   console.log(disabledButtonForm);
	//when the time is end
 /*   if(tsuffix == "pre-order-with-time" && startPreorder != "" && durationEnd <=0  )
    {
          $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" disabled>'+ 
          '<input id="pre" value="pre-order" hidden="" >'+  
          '<span id="buttonTXT" data-add-to-cart-text="" >Preorder Now</span>'+   
          '</button>');
    
    }else{
      //when only is pre-order
      if(tsuffix == "pre-order")
      {
         /* $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" disabled>'+ 
          '<input id="pre" value="pre-order" hidden="" >'+  
          '<span data-add-to-cart-text="" >Preorder Now</span>'+   
          '</button>');*/

    /*  }else{
        //when the4 time is not end
        if(tsuffix == "pre-order-with-time" && durationEnd > 0 && disabledButtonForm != "1"){
             $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" >'+ 
            '<input id="pre" value="pre-order" hidden="" >'+  
            '<span id="buttonTXT" data-add-to-cart-text="" >Preorder Now.</span>'+   
            '</button>');
            $("#BIS_trigger").html("");
        }
      
      }
      */
      
      
      
      if(tsuffix == "pre-order-with-time" && disabledButtonForm == "1" ){
      	  $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" disabled>'+ 
          '<input id="pre" value="pre-order" hidden="" >'+  
          '<span id="buttonTXT" data-add-to-cart-text="" >Preorder Now</span>'+   
          '</button>');
      }else{
        if(tsuffix == "pre-order-with-time" && disabledButtonForm == "2" ){
      		      	  $("#r").html('<button type="submit" name="add" id="add" class="Button Button--primary" data-add-to-cart="" data-component="CartButton" >'+ 
          '<input id="pre" value="pre-order" hidden="" >'+  
          '<span id="buttonTXT" data-add-to-cart-text="" >Preorder Now</span>'+   
          '</button>');
        }
          
      		
      }
    

 setTimeout(fdisabledButton,50);
    
});
 

//WHEN BUTTON IS SOLD OUT OR PREVIEW THIS FUNCTION DISABLED THAT BUTTON
function fdisabledButton(){
  var data =$("#buttonTXT").text();
 if($("#buttonTXT").text() == "Sold Out" || $("#buttonTXT").text() == "Preview"){
  	document.getElementById("add").disabled=true;
  }else{
    if($("#buttonTXT").text() == "Buy Now"){
    	document.getElementById("add").disabled=false;
    }
  }

}


//count preorder time
document.addEventListener('DOMContentLoaded', () => { 

   var pre = $("#pre").val();
   var zone=new Date().toTimeString().slice(9);

   console.log(zone);
   if(pre == "pre-order-with-time" ){
           

         var h=$("#ph").val();
         var m=$("#pm").val();
         var s=$("#ps").val();
         var d=$("#pd").val();
         var month=$("#pmonth").val();
         var ampm=$("#pampm").val();
                                
         var bh=$("#pbh").val();
         var bm=$("#pbm").val();
         var bs=$("#pbs").val();
         var bd=$("#pbd").val();
         var bmonth=$("#pbmonth").val();
         var bampm=$("#pbampm").val();

     
         //Mountain Daylight Time IS IN THE CUSTOMS FIELDS 
     
         //PST
         //if(zone == "GMT-0700 (Pacific Daylight Time)"){*/
         //GMT-0700 (Pacific Daylight Time)
     	 //(UTC-08:00)Pacific Time(US & Canada)
         if(zone.match(/GMT-0700/)){
            console.log("pacifico");
            h=parseInt(h)-1;
            bh=parseInt(bh)-1;
         }
         //CT7
         //GMT-0500 (Central Daylight Time)
     	 //(UTC-06:00) Central Time(US & CANADA)
         if(zone.match(/GMT-0500/)){
            console.log("central time");
            h=parseInt(h)+1;
            bh=parseInt(bh)+1;
         }
         //ET
         //GMT-0400 (Eastern Daylight Time)
         //(UTC-05:00) Eastern Time(US & CANADA)
     	 if(zone.match(/GMT-0400/)){
            console.log("Eastern");
            h=parseInt(h)+2;
            bh=parseInt(bh)+2;
         }
         console.log("fecha");
         console.log(new Date());
         if(h != 999 && h != 888 ){
      		 const DATE_TARGET = new Date(month+"/"+d+"/"+2021+" "+h+":"+m+" "+ampm);
              const DATE_ENDTARGET = new Date(bmonth+"/"+bd+"/"+2021+" "+bh+":"+bm+" "+bampm);
              const SPAN_DAYS = document.querySelector('span#days');
              const SPAN_HOURS = document.querySelector('span#hours');
              const SPAN_MINUTES = document.querySelector('span#minutes');
              const SPAN_SECONDS = document.querySelector('span#seconds');


              const MILLISECONDS_OF_A_SECOND = 1000;
              const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
              const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
              const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24

              function updateCountdown() {
                  // Calcs
                  const NOW = new Date()
                  const DURATION = DATE_TARGET - NOW;
                  const DURATIONEND = DATE_ENDTARGET-NOW;
                  $("#durationEnd").val(DURATIONEND);
                  const REMAINING_DAYS = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
                  const REMAINING_HOURS = Math.floor((DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR);
                  const REMAINING_MINUTES = Math.floor((DURATION % MILLISECONDS_OF_A_HOUR) / MILLISECONDS_OF_A_MINUTE);
                  const REMAINING_SECONDS = Math.floor((DURATION % MILLISECONDS_OF_A_MINUTE) / MILLISECONDS_OF_A_SECOND);

                 console.log(DURATIONEND);
                  if(DURATION >= 0 ){//when the time not end
                    console.log("time continue1");
                    $("#x").val("1");
                    document.getElementById("add").disabled=true;  
                  }else{//when the time end
                      if(DURATIONEND <= 0)
                  		{
                        console.log("time end");
                    	document.getElementById("add").disabled=true;  
                        $("#x").val("1");
                        /*$('#showButton').html("<br><button href='#' style='' id='BIS_trigger' class='Button Button--primary' >EMAIL WHEN AVAILABLE</button>");*/
                        }else{
                           console.log("time continue");
                  	 		document.getElementById("add").disabled=false; 
                            $("#x").val("2");
                            $("#BIS_trigger").html("");
                  		}
                  }
                 

              }
           
        updateCountdown();
        setInterval(updateCountdown, MILLISECONDS_OF_A_SECOND);  
    	}
   }
	   
});